module.exports = __webpack_public_path__ + "static/media/Locations.0a07f831.svg";